import { CircularProgress, Grid } from "@mui/material";

import React from "react";

interface IOverlaySpinnerProps {
  size?: number;
  message?:string;
}

export default function OverlaySpinner(props: IOverlaySpinnerProps) {
  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        right: 0,
        bottom: 0,
        textAlign: "center",
        background: "rgba(0, 0, 0, 0.05)",
        zIndex: 9999,
      }}
    >
      <Grid item>
        <>{props.message}<CircularProgress size={props.size} /></>
      </Grid>
    </Grid>
  );
}
